import { Box } from "@mui/material";
import { IN_REPAIR_BADGE_BASE_SX, IN_REPAIR_SC_GROUP_STYLE } from "../data/inRepairListingConstants";

const InRepairScGroupBadge = ({ value }) => {
  if (!value) return null;

  return (
    <Box
      component="span"
      sx={{
        ...IN_REPAIR_BADGE_BASE_SX,
        backgroundColor: IN_REPAIR_SC_GROUP_STYLE.bg,
        color: IN_REPAIR_SC_GROUP_STYLE.color,
      }}
    >
      {value}
    </Box>
  );
};

export default InRepairScGroupBadge;
